import { Component, Vue } from 'vue-property-decorator';

import VueRecaptcha from 'vue-recaptcha';
import Single from '@/components/single/single.vue';

@Component({
    components: {
        Single,
        VueRecaptcha,
    },
    metaInfo() {
        return {
            title: 'Sign up',
        };
    },
})
export default class SignUp extends Vue {
    filename: string | null = null;

    test(iets: any) {
        if (iets.target.files[0]) {
            this.filename = iets.target.files[0].name;
        }
    }

    onSubmit() {
        (this.$refs.invisibleRecaptcha as any).execute()
    }

    onVerify(response: string) {
        console.log('Verify: ' + response);
    }

    onExpired() {
        console.log('Expired');
    }
}
